import React from "react";
import dataBox from "../assets/fake-data/data-box";

import dataRoadMap from "../assets/fake-data/data-roadmap";

import dataProject from "../assets/fake-data/dataProject";

import About from "../components/about/About";
import Banner from "../components/banner/Banner";

import Footer from "../components/footer/Footer";

import Project from "../components/project/Project";
import Roadmap from "../components/roadmap/Roadmap";
import Speciality from "../components/speciality/Speciality";

import Skills from "../components/skills/Skills";

function Home01(props) {
  return (
    <div className="home-1 wrapper">
      <Banner />
      <Skills />

      <About />

      <Speciality data={dataBox} />

      <Roadmap data={dataRoadMap} />
      {/* <Portfolio data={dataPortfolio} /> */}

      <Project data={dataProject} />

      {/* <Team data={dataTeam} /> */}

      {/* <Testimonials data={dataTestimonials} /> */}

      {/* <Faqs data={dataFaqs} /> */}

      {/* <Create /> */}

      <Footer />
    </div>
  );
}

export default Home01;
